import { AccessTree, MANAGEMENT_ROLES } from "@intility/access-tree";
import Section from "@intility/bifrost-react/Section";
import { useCallback } from "react";
import { deleteManagementTuple, writeManagementTuple } from "~/api/management";
import { useCapabilities } from "~/auth/capabilities";
import { auth } from "~/auth/index";
import { PageLayout } from "~/components/layout/PageLayout";

const MANAGEMENT_TREE_BASE = (
  import.meta.env.VITE_MANAGEMENT_API_URL || "/management-api"
).replace(/\/api$/, "");

async function getToken(): Promise<string> {
  return auth.getToken();
}

export default function ManagementAccessTree() {
  const { can } = useCapabilities();

  const writeTuple = useCallback(
    async (tuple: { user: string; relation: string; object: string }) => {
      await writeManagementTuple(tuple);
    },
    [],
  );

  const deleteTuple = useCallback(
    async (tuple: { user: string; relation: string; object: string }) => {
      await deleteManagementTuple(tuple);
    },
    [],
  );

  return (
    <PageLayout
      title="Management Access Tree"
      breadcrumbs={[
        { label: "Home", to: "/" },
        { label: "Management" },
        { label: "Access Tree" },
      ]}
      description="View the management-store hierarchy and grants (owner / maintainer / viewer). Switch to another user to inspect or edit their access."
      fullWidthBody
    >
      <Section>
        <Section.Content>
          <AccessTree
            queryApiBaseUrl={MANAGEMENT_TREE_BASE}
            height="calc(100dvh - 240px)"
            getToken={getToken}
            showUserPicker
            viewerDisplayName={
              auth.keycloak.tokenParsed?.name ??
              auth.keycloak.tokenParsed?.preferred_username ??
              "Yourself"
            }
            viewerSubject={
              auth.keycloak.tokenParsed?.sub
                ? `user:${auth.keycloak.tokenParsed.sub}`
                : undefined
            }
            editing={
              can("governance.write") ? { writeTuple, deleteTuple } : undefined
            }
            roleConfig={MANAGEMENT_ROLES}
            alwaysExpandable
          />
        </Section.Content>
      </Section>
    </PageLayout>
  );
}
